import React from 'react';

export default class ShFeatures extends React.Component {
  constructor(props) {
    super(props);
    this.ref = React.createRef();
  }

  componentDidMount() {
    this.ref.current.features = this.props.listing.features;
  }

  render() {
    return (
      <sh-features ref={this.ref}></sh-features>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/listing-detail/sh-wrappers/sh-features.js